import { render } from "./CardPreviewSMS.vue?vue&type=template&id=f81ceb96"
import script from "./CardPreviewSMS.vue?vue&type=script&lang=js"
export * from "./CardPreviewSMS.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__